<template>
  <div class="inquiry_warp">
    <van-overlay :show="inquiryShow" >
      <div class="focus_main">
        <div class="focus_pop">
          <div class="inquiry_title">索取样品</div>
          <div class="focut_content">
            <div class="input_read" style="background: #fff;border: 1px solid #efefef">
              <p>姓名</p>
              <van-field type="text" v-model="name" maxlength="11" placeholder="请输入姓名 " />
            </div>
            <div class="input_read" style="background: #fff;border: 1px solid #efefef">
              <p>公司</p>
              <van-field type="text" v-model="companyName" maxlength="11" placeholder="请输入公司名" />
            </div>
            <div class="input_read">
              <p>手机</p>
              <van-field type="tel" v-model="phone"  readonly maxlength="11" placeholder="请输入手机号"  />
              <!-- <p>{{phone}}</p> -->
            </div>

            <van-field
              type="textarea"
              class="text_area "
              placeholder="备注"
              :autosize=" { maxHeight:'1.4rem', minHeight:'1.4rem'}"
              placeholder-class="placeholder"
              fixed="true"
              v-model="content"
              name="text"
              maxlength="100"
              show-word-limit
            />
          </div>
          <div class="submit_btn">
            <span @click="resetForm">取消</span>
            <span @click="submit">提交</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
export default {
  name: "inquiry",
  components:{
  },
  data() {
    return {
      name:'',
      phone:'',
      companyName:'',
      content:'',
      inquiryShow:false,
      isHasMob:false,
      exInfo:{}
    } 
  },
  computed:{
    ...mapGetters({
      exhibitorId:'company/getExhibitorId',
      companyId:'company/getCompanyId',
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId'
    }),
  },
  methods:{
   //提交 完成后返回上一页  
   ...mapActions({
     addEnquiry:'company/addEnquiry',
   }),
   open(exInfo){
     if(!this.userInfo.phone){
      this.$Myapollo.unverifiedDialog(this);
      return
     }
     this.exInfo=exInfo
     this.name = this.userInfo.name || this.userInfo.nickName;
     this.phone = this.userInfo.phone;
     this.companyName=this.userInfo.company
     this.inquiryShow=true;
   },
   async submit(){
     if(!(/^1[23456789]\d{9}$/.test(this.phone))){ 
        this.$toast("手机号码有误，请重填");  
        return false; 
      }
      if((/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.content))){
        this.$toast.fail('请勿输入手机号');
        return;
      }
     let userInfo = {
       name:this.userInfo.name,
       nickName:this.userInfo.nickName,
       avatarUrl:this.userInfo.avatarUrl,
       company:this.companyName
     }
     
     let body = {
          compId: this.companyId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          userId: this.userInfo.userId,
          name: this.name,
          phone: this.phone,
          remark: this.content,
          userInfo: JSON.stringify(userInfo),
          exInfo:JSON.stringify(this.exInfo)
        }
      
      if(this.name && this.phone && this.content) {
        let result = await this.addEnquiry(body);
        if(result.result){
          this.$toast.success('发送成功');
        } else {
          this.$toast.fail(result.message || '发送失败');
        }
        this.resetForm();
      } else {
        this.$toast('请留下备注信息');
      }
   },
   resetForm(){
     this.name = '';
     this.phone = '';
     this.content="";
     this.inquiryShow=false;
   }
  }
};
</script>


<style lang="scss" scoped>
  .inquiry_warp{
    z-index: 200;
    position: relative;
    .focus_main{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .focus_pop {
      width: 5.6rem;
      height: 6.36rem;
      padding: 0.35rem 0.35rem 0;
      background: #fff;
      border-radius: 0.15rem;
      position: relative;
      .inquiry_title {
        font-size: 0.3rem;
        text-align: center;
        color: #333;
        line-height: 1.2;
        margin-bottom: 0.23rem;
        letter-spacing: 1px;
        padding-left: 1px;
        font-weight: 600;
      }
      .submit_btn {
        height: .9rem;
        width: 100%;
        display: flex;
        align-items: center;
        position: absolute;
        border-top: 1px solid #d2d3d5;
        left: 0;
        right: 0;
        bottom: 0;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          height: .89rem;
          border: none;
          border-radius: 0;
          color: #333;
          font-size: 0.3rem;
          width: 100%;
          &:first-child {
            border-right: 1px solid #d2d3d5;
          }
          &:last-child {
            color: #fe5502;
          }
        }
      }
      .focut_content {
        .input_read {
          background: #eee;
          color: #666;
          padding: 0 0.2rem;
          display: flex;
          justify-content: space-between;
          height: 0.7rem;
          margin-bottom: 0.2rem;
          align-items: center;
          // line-height: 0.7rem;
          p {
            font-size: 0.26rem;
            width: 30%;
          }
          ::v-deep
          .van-field{
            padding: 0;
            background: transparent;
            line-height: inherit;
            .van-field__word-limit{
              margin-top: 0;
              font-size: 0.24rem;
            }
            input {
            // width: 70%;
            color: #666;
            outline: none;
            border: none;
            background: transparent;
            
            text-align: right;
            // padding: 0.15rem 0;
            font-size: 0.26rem;
            box-sizing: border-box;
            // height: 35px;
            }
            input[type="tel"]{
              color: #666;
              background: #eee;
            }
          } 
        }
        .placeholder {
          font-size: .26rem;
        }
        ::v-deep .text_area {
          border: 1px solid #eee;
          height: 1.4rem;
          padding: 0.1rem 0.2rem;
          box-sizing: border-box;
          width: 100%;
          font-size: 0.26rem;
          line-height: 0.38rem;
          color: #333;
           .van-field__body {
            .van-field__control {
              min-height: 0.95rem;
              font-size: 0.26rem;
              line-height: 0.38rem;
              &::-webkit-input-placeholder {
                /* WebKit browsers */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
            }
          }
          .van-field__word-limit {
            font-size: 0.24rem;
            margin-top:-0.05rem;
          }
          
        }
      }
    }
  }
</style>

